import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'

export default class extends Component {
  render () {
    const {connectDragSource, isDragging, editing,
      item, url, active} = this.props

    const component = <li className={cn('group-item', {active, isDragging})}>
      <NavLink to={url} activeClassName='active'>
        {item.name}
      </NavLink>
    </li>

    return editing
      ? connectDragSource(component)
      : component
  }
}



// WEBPACK FOOTER //
// ./app/components/sidebar/GroupItem.js